import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImage, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { guardarDatoPersonalesUsuario, obtenerDatosUsuario } from '../../../../../../actions/user/user.actions';
import { datosUsuario, datosUsuarioRequest } from '../../../../../../models/usuarios/usuarios.models';
import { Alerta } from '../../../../../../helpers/alerts/alert';

export type DatosPersonalesFormProps = {
	onComplete: (estaCompleto: boolean) => void;
	idUsuarioElsa: number;
	accion: string;
}

const DatosPersonalesForm: React.FC<DatosPersonalesFormProps> = ({ onComplete, idUsuarioElsa, accion }) => {
	const [datosCompletos, setDatosCompletos] = useState(false);
	const [cargando, setCargando] = useState(false);
	const [mostrarCargando, setMostrarCargando] = useState(true);
	const [formularioValido, setFormularioValido] = useState(false);
	const [formularioDatosPersonales, setFormularioDatosPersonales] = useState<datosUsuarioRequest>({
		nombreCompleto: '',
		primerApellido: '',
		segundoApellido: '',
		correo: '',
		telefonoPersonal: '',
		fotoPerfil: '',
		fotoPerfilBase64: '',
	});

	const {
		nombreCompleto,
		primerApellido,
		segundoApellido,
		correo,
		telefonoPersonal,
		fotoPerfil,
		fotoPerfilBase64
	} = formularioDatosPersonales;

	function validarCamposFormulario() {
		let esValido: boolean = true;

		if (!nombreCompleto.trim()) {
			esValido = false;
		}

		if (!primerApellido.trim()) {
			esValido = false;
		}

		if (!segundoApellido.trim()) {
			esValido = false;
		}

		if (telefonoPersonal.trim() && telefonoPersonal.length < 10) {
			esValido = false;
		}

		if (!fotoPerfil.trim()) {
			esValido = false;
		}

		if (!fotoPerfilBase64.trim()) {
			esValido = false;
		}

		return {
			esValido
		}
	}

	const handleInputChange = (name: string, value: string, autocompletado: boolean = false) => {

		if (name === "telefonoPersonal" && value.length > 10) {
			return;
		}

		if(accion == "editar" && autocompletado && name == "fotoPerfil") {
			value = "sinCambios";
		}

		setFormularioDatosPersonales((prev: any) => ({
			...prev,
			[name]: value
		}));
	}

	const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		if (event.target.files && event.target.files[0]) {
			const file = event.target.files[0];
			let timestamp = new Date().getTime();
			const extension = file.name.split('.').pop();
			const fotoPerfilURL = `fotoPerfil_${idUsuarioElsa}_${timestamp}.${extension}`;

			const reader = new FileReader();
			reader.onload = () => {
				if (reader.result) {
					const base64String = reader.result.toString();
					const cleanBase64 = base64String.substring(base64String.indexOf(",") + 1);

					setFormularioDatosPersonales((prev: any) => ({
						...prev,
						fotoPerfil: fotoPerfilURL,
						fotoPerfilBase64: cleanBase64,
					}));
				}
			};
			reader.readAsDataURL(file);
		}
	};

	async function obtenerDatosUsuarioAsync() {
		setMostrarCargando(true);
		const resp = await obtenerDatosUsuario(idUsuarioElsa!.toString());
		if (resp.success) {
			const datosUsuarioResponse: datosUsuario = resp.data;

			Object.entries(datosUsuarioResponse).forEach(([key, value]) => {
				if (key in formularioDatosPersonales) {
					handleInputChange(key, value, true);
				}
			});

			handleInputChange("fotoPerfilBase64", "sinCambios", true);

			setDatosCompletos(datosUsuarioResponse.datosCompletos);
			if(datosUsuarioResponse.datosCompletos) setFormularioValido(true)

			onComplete(accion == "editar" ? false : datosUsuarioResponse.datosCompletos);
		}

		
		setMostrarCargando(false)
		

	}

	async function guardarDatosPersonalesAsync() {
		const { esValido } = validarCamposFormulario();

		try {
			
			if (esValido) {
				setFormularioValido(true);
				setCargando(true);
				const resp = await guardarDatoPersonalesUsuario(idUsuarioElsa, formularioDatosPersonales);
				if (resp.success) {
					Alerta(resp.message, resp.success);
					setDatosCompletos(resp.success);
					onComplete(resp.success);
					setCargando(false);
				} else {
					Alerta(resp.message, resp.success);
				}
			} else {
				setFormularioValido(false);
			}
		} catch (err) {
			console.error("Ocurrió un error al guardar los datos.")
		}
	}

	useEffect(() => {
		obtenerDatosUsuarioAsync();
	}, [])

	return (
		<div className='flex flex-col gap-5'>
			
			{
				mostrarCargando ? (
					<div className='flex flex-col justify-center align-middle items-center p-5'>
						<span className="loading loading-spinner text-BlueDAR loading-lg"></span>
					</div>
				) : (
					<div>
						<div className='flex flex-col gap-5'>
							<div className='grid grid-cols-2 justify-start gap-10 w-full'>
								<div className='w-full'>
									<label className='font-semibold'>Nombre completo*</label>
									<input
										type="text"
										value={nombreCompleto}
										onChange={(e) => handleInputChange("nombreCompleto", e.target.value)}
										placeholder={"Escriba el nombre completo"}
										className="input input-bordered w-full"
										required={true}
									/>
								</div>
								<div className='w-full'>
									<label className='font-semibold'>Apellido paterno*</label>
									<input
										type="text"
										value={primerApellido}
										onChange={(e) => handleInputChange("primerApellido", e.target.value)}
										placeholder={"Escriba el apellido paterno"}
										className="input input-bordered w-full"
										required={true}
									/>
								</div>
								
								<div className='w-full'>
									<label className='font-semibold'>Apellido materno*</label>
									<input
										type="text"
										value={segundoApellido}
										onChange={(e) => handleInputChange("segundoApellido", e.target.value)}
										placeholder={"Escriba el apellido materno"}
										className="input input-bordered w-full"
										required={true}
									/>
								</div>
								
								<div className='w-full'>
									<label className='font-semibold'>Correo institucional*</label>
									<input
										type="email"
										value={correo}
										onChange={(e) => handleInputChange("correo", e.target.value)}
										placeholder={"escriba el correo institucional"}
										className="input input-bordered w-full"
										disabled
									/>
								</div>
								
								<div className='w-full'>
									<label className='font-semibold'>Número de teléfono*</label>
									<input
										type="number"
										value={telefonoPersonal}
										onChange={(e) => handleInputChange("telefonoPersonal", e.target.value)}
										placeholder={"EScriba el número de teléfono"}
										className="input input-bordered w-full"
										maxLength={10}
									/>
								</div>
								
							</div>
							<div>
								<div>
									<p className='font-semibold'>Sube una foto de perfil *</p>
								</div>
								<div className='flex flex-col justify-center align-middle items-center border-dashed border-2 p-5 gap-2'>
									<div>
										<FontAwesomeIcon icon={faImage} color='#2d6bcf' size='3x' />
									</div>
									<p>Sube un archivo JPEG, JPE o PNG con un peso máximo de 3MB</p>
									<input
										type="file"
										className="file-input file-input-bordered file-input-xs w-full max-w-xs"
										onChange={handleFileChange}
										content={formularioDatosPersonales.fotoPerfil}
									/>
								</div>
							</div>
							<div>
								{
									!formularioValido && (
										<p className='text-red-500'>Uno o varios campos se encuentran vacíos o son inválidos.</p>
									)
								}
								<div className='flex justify-end'>
									<button
										className='btn btn-sm bg-BlueDAR'
										onClick={guardarDatosPersonalesAsync}
									>
										{
											cargando && (
												<div>
													<span className="loading loading-spinner loading-xs"></span>
												</div>
											)
										}
										<p className='text-white'>Guardar cambios</p>
									</button>
								</div>
							</div>
						</div>
					</div>
				)
			}
		</div >
	);
};

export default DatosPersonalesForm;
